import {configureStore} from "@reduxjs/toolkit";
import plantObjectsReducer from "./scada/plant/PlantObjectsSlice";
import scadaFilterValuesReducer from "./scada/plants/ScadaFilterValuesSlice";
import alarmSelectedReducer from "./scada/plants/AlarmSelectedSlice";
import controlFilterReducer from "./control/ControlFiltersSlice";

import themeReducer from "./theme/theme.store";

import installatorsReducer from "./form/installators.store";
import essTypesReducer from "./form/essTypes.store";
import trackerTypesReducer from "./form/trackerTypes.store";

import trackersReducer from "./scada/tracker/trackers.store";

import essReducer from "./scada/ess/ess.store";

import immersionHeatersReducer from "./scada/immersion_heater/immersionHeater.store";

import authorizationReducer from "./auth/authorization.store";

import checkpointsBlockReducer from "./control/checkpointsBlock.store";

import pvPanelTypesReducer from "./form/pvPanelTypes.store";

import controlPlantsReducer from "./control/plants.store";

import alarmTypeReducer from "./scada/alarms/AlarmTypeStore";

import privacyReducer from "./privacy/privacy.store";

import equipmentReducer from "./form/equipment.store";

export const store = configureStore({
  reducer: {
    essTypes: essTypesReducer,
    plantObjects: plantObjectsReducer,
    scadaFilterValues: scadaFilterValuesReducer,
    alarmSelected: alarmSelectedReducer,
    installators: installatorsReducer,
    trackerTypes: trackerTypesReducer,
    authorization: authorizationReducer,
    checkpointsBlock: checkpointsBlockReducer,
    theme: themeReducer,
    trackers: trackersReducer,
    essState: essReducer,
    immersionHeaters: immersionHeatersReducer,
    pvPanelTypes: pvPanelTypesReducer,
    plantsToControl: controlPlantsReducer,
    controlFilters: controlFilterReducer,
    alarmTypes: alarmTypeReducer,
    equipments: equipmentReducer,
    privacy: privacyReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
